import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  TextInput,
  NumberInput,
  EmailField,
} from 'react-admin'

import FilterComponent from '../../components/Filter'

const validateIntegerId = value => {
  if (value === undefined || value === null || value === '') return undefined
  if (!Number.isInteger(value) || value < 1 || value > 2147483647)
    return 'Id phải là số nguyên dương hợp lệ (tối đa 2147483647)'
  return undefined
}

const UserDetailsFilter = props => (
  <FilterComponent {...props}>
    <NumberInput
      label="Id"
      source="id"
      alwaysOn
      validate={validateIntegerId}
      min={1}
      max={2147483647}
      step={1}
    />
    <TextInput label="Name" source="name" alwaysOn />
    <TextInput label="Username" source="username" alwaysOn />
    <TextInput label="Email" source="email" alwaysOn />
    <TextInput label="Phone number" source="phoneNumber" alwaysOn />
  </FilterComponent>
)

const UserDetailsList = props => (
  <List
    filters={<UserDetailsFilter />}
    {...props}
    exporter={false}
    sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <TextField source="id" />
      <TextField source="username" />
      <TextField source="name" />
      <EmailField source="email" />
      <TextField source="phoneNumber" />
      <DateField source="createdAt" />
      <TextField source="credits" />
      <ShowButton />
    </Datagrid>
  </List>
)

export default UserDetailsList
